var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content container"},[(_vm.error)?_c('h2',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.error))]):_c('page-loader')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }